import { render } from "./SpmGraph.vue?vue&type=template&id=7c351ee5&scoped=true"
import script from "./SpmGraph.vue?vue&type=script&lang=ts"
export * from "./SpmGraph.vue?vue&type=script&lang=ts"

import "./SpmGraph.vue?vue&type=style&index=0&id=7c351ee5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c351ee5"

export default script